const binding = { modules: {}, dataActions: {} };

    (binding.modules['ecomm-mobile-iso'] = {
        c: () => require('partner/modules/ecomm-mobile-iso/ecomm-mobile-iso.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'ecomm-mobile-iso',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/ecomm-mobile-iso'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|ecomm-mobile-iso|ecomm-mobile-iso'] = {
                c: () => require('partner/modules/ecomm-mobile-iso/ecomm-mobile-iso.view.tsx'),
                cn: '__local__-__local__-ecomm-mobile-iso'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };